import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

type NoSuggestionsRecommendationsWrapperProps = {
    $isNavBar: boolean;
};

export const NoSuggestionsWrapper = styled.div`
    width: 100%;
`;

export const NoSuggestionsRecommendationsWrapper = styled.div<NoSuggestionsRecommendationsWrapperProps>`
    display: flex;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('400')};
    width: 100%;

    ${({ $isNavBar }) =>
        $isNavBar &&
        purpurMedia('lg')`
            display: flex;
            flex-wrap: nowrap;
            gap: ${getPurpurSpacing('600')};
        `};
`;

export const ProductSuggestionsWrapper = styled.div`
    width: 100%;
`;
